exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html {\n  height: 100%; }\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n  min-height: 100%;\n  display: flex;\n  font-family: 'Montserrat', sans-serif;\n  background-color: #0E202E; }\n\n#root {\n  display: flex;\n  flex: 1;\n  min-width: 675px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/index.scss
// module id = 941
// module chunks = 0